import useAuthStore from '@/stores/useAuthStore';
import useAppStore from '@/stores/useAppStore';
import { lxFlowUtils } from '@dativa-lv/lx-ui';
import useViewStore from '@/stores/useViewStore';

export default (router) => {
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore();
    const appStore = useAppStore();
    const viewStore = useViewStore();

    viewStore.title = null;
    await lxFlowUtils.beforeEach(to, from, next, appStore, authStore);
  });
  router.afterEach(async (to, from) => {
    const appStore = useAppStore();
    await lxFlowUtils.afterEach(to, from, appStore);
  });
};
